import { intlShape, injectIntl } from 'react-intl';
import { VODCSSModules } from 'shared/utils/wix-connect';

import Icon from 'shared/components/icon/icon';
import WithTooltip from '../with-tooltip/with-tooltip';
import ChannelInfoButton from 'widget/components/channel-actions/channel-info-button';
import ChannelSubscriptionLabel from 'widget/components/channel-actions/channel-subscription-label';
import AccountButtonCompact from '../account-button/account-button';

import translations from '../../translations';
import styles from './channel-actions.styl';

import { sides } from 'shared/constants/popout';


@injectIntl
@VODCSSModules(styles)
export default class ChannelActions extends React.Component {

  static propTypes = {
    channelData: React.PropTypes.object,
    intl: intlShape,

    canShowCloseButton: React.PropTypes.bool,
    canShowChannelShare: React.PropTypes.bool,
    canShowChannelInfo: React.PropTypes.bool,
    canShowSignIn: React.PropTypes.bool,
    canShowSubscriptionButton: React.PropTypes.bool,

    onShareRequested: React.PropTypes.func,
    onChannelInfoRequested: React.PropTypes.func,
    onSubscriptionRequested: React.PropTypes.func,
    onUserLogin: React.PropTypes.func,
    onUserLogOut: React.PropTypes.func,
    onSubscriptionCancelClick: React.PropTypes.func,
    onClose: React.PropTypes.func,
  };

  get formatMessage() {
    return this.props.intl.formatMessage;
  }

  wrapWithTooltip(content, tooltipMessage) {
    return (
      <WithTooltip tooltip={tooltipMessage}
                   className={styles.item}
                   innerClassName={styles['tooltip-inner']}>
        {content}
      </WithTooltip>
    );
  }

  get shareButton() {
    const { onShareRequested, canShowChannelShare } = this.props;

    if (!canShowChannelShare) {
      return null;
    }

    const tooltipMessage = this.formatMessage(translations.shareButtonTooltip);
    const content = (
      <Icon name="share"
            className={styles.icon}
            onClick={onShareRequested} />
    );

    return this.wrapWithTooltip(content, tooltipMessage);
  }

  get channelInfoButton() {
    const { channelData, onChannelInfoRequested, canShowChannelInfo } = this.props;

    if (!canShowChannelInfo) {
      return null;
    }

    const tooltipMessage = this.formatMessage(translations.channelInfoTooltip);
    const content = (
      <ChannelInfoButton className={`${styles.icon} ${styles['icon-channel-info']}`}
                         channelData={channelData}
                         onClick={onChannelInfoRequested} />
    );

    return this.wrapWithTooltip(content, tooltipMessage);
  }

  get channelSubscriptionButton() {
    const { channelData, onSubscriptionRequested, canShowSubscriptionButton } = this.props;

    if (!canShowSubscriptionButton) {
      return null;
    }

    const tooltipMessage = (
      <ChannelSubscriptionLabel dealInfo={channelData.dealInfo}
                                styleName="channel-subscription-tooltip-content" />
    );
    const content = (
      <Icon name="paid"
            className={`${styles.icon} ${styles['icon-paid']}`}
            onClick={onSubscriptionRequested} />
    );

    return this.wrapWithTooltip(content, tooltipMessage);
  }

  get membershipActions() {
    const {
      channelData,
      onUserLogin,
      onUserLogOut,
      onSubscriptionRequested,
      onSubscriptionCancelClick,
      canShowSignIn,
    } = this.props;

    if (!canShowSignIn) {
      return null;
    }

    return (
      <AccountButtonCompact styleName="item icon"
                            channelData={channelData}
                            popoutSide={sides.TOP}
                            onUserLogin={onUserLogin}
                            onUserLogout={onUserLogOut}
                            onSubscribeClick={onSubscriptionRequested}
                            onSubscriptionCancelClick={onSubscriptionCancelClick} />
    );
  }

  get closeButtonWithTooltip() {
    const { onClose } = this.props;

    const tooltipMessage = this.formatMessage(translations.close);
    const content = (
      <Icon name="exit"
            className={`${styles.icon} ${styles['icon-close']}`}
            onClick={onClose} />
    );

    return this.wrapWithTooltip(content, tooltipMessage);
  }

  get closeButtonWithLabel() {
    const { onClose } = this.props;

    const label = this.formatMessage(translations.close);

    return (
      <div className={styles.item}
           onClick={onClose}>
        <div className={styles.icon}>
          <Icon name="exit"
                className={`${styles.icon} ${styles['icon-close']}`} />
          <span className={styles.label}>
            {label}
          </span>
        </div>
      </div>
    );
  }

  get closeButton() {
    const { canShowCloseButton } = this.props;

    if (!canShowCloseButton) {
      return null;
    }

    const {
      shareButton,
      channelInfoButton,
      channelSubscriptionButton,
      membershipActions,
      closeButtonWithTooltip,
      closeButtonWithLabel,
    } = this;

    const buttonsExceptClose = [
      shareButton,
      channelInfoButton,
      channelSubscriptionButton,
      membershipActions,
    ];

    return _.some(buttonsExceptClose) ? closeButtonWithTooltip : closeButtonWithLabel;
  }

  render() {
    return (
      <nav styleName="container">
        {this.shareButton}
        {this.channelInfoButton}
        {this.channelSubscriptionButton}
        {this.membershipActions}
        {this.closeButton}
      </nav>
    );
  }
}



// WEBPACK FOOTER //
// ./src/widget/views/desktop/compact/components/channel-actions/channel-actions.js